import { IndexedDb, IndexedDbKey } from "@/services/indexedDb";
import { type UserToken } from "@/services/user/userTypes";

/**
 * Handles token storing and retrieval in/from browser.
 */
export const TokenService = {
  get: async (): Promise<UserToken | null> => {
    return IndexedDb.get(IndexedDbKey.UserToken);
  },

  store: (token: UserToken): void => {
    IndexedDb.set(IndexedDbKey.UserToken, token);
  },

  delete: (): void => {
    IndexedDb.delete(IndexedDbKey.UserToken);
  },
};
